import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { StorageService } from '../../../../core/services/api/storage.service';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { RoleService } from '../../../../core/services/role/role.service';
import { SignalRService } from '../../../../core/services/signalR/signalr.service';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-logout-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './logout-modal.component.html',
  styleUrl: './logout-modal.component.scss',
})
export class LogoutModalComponent {
  constructor(
    private readonly authService: AuthService,
    private readonly storageService: StorageService,
    private readonly modalService: NgbModal,
    private readonly router: Router,
    private readonly roleService: RoleService,
    private readonly languageService: LanguageService,
    private signalRService: SignalRService
  ) {}

  @Output() close = new EventEmitter<void>();

  closeModal() {
    this.modalService.dismissAll();
  }

  async logout() {
    this.closeModal();
    this.authService.logout().subscribe({
      next: async () => {
        this.storageService.clearAll();
        this.languageService.loadSavedLang();
        this.roleService.updateRoles();

        try {
          await this.signalRService.disconnectAll(true);
          console.log('All SignalR hubs disconnected (force).');
        } catch (error) {
          console.error('Failed to disconnect SignalR hubs:', error);
        }

        this.router.navigateByUrl('/auth').then(() => window.location.reload());
      },
      error: (err) => {
        console.error('Logout failed:', err);
        this.router.navigate(['/auth']);
      },
    });
  }
}
